<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
body, html {
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: linear-gradient(135deg, #e0f7fa, #80deea);
	font-family: Arial, sans-serif;
}
</style>
